import { useTranslation } from "react-i18next";
import { Btn } from "@/ui/btn/Btn";
import { useMedia } from "@/hooks/useMedia";

interface InstagramSearchSelectionSelectProps {
  selected: number;
  count: number;
  loading?: boolean;
  onClick?: () => void;
}

export const InstagramSearchSelectionSelect: React.FC<
  InstagramSearchSelectionSelectProps
> = ({ selected, count, loading, onClick }) => {
  const { t } = useTranslation();
  const xs = useMedia("<xs");

  const isSelectedAll = selected > 0 && selected === count;

  return (
    <Btn
      text={
        xs === true
          ? undefined
          : isSelectedAll === false
            ? t("selection.selectAll")
            : t("selection.unselectAll")
      }
      endIcon={
        isSelectedAll === false ? "confirm_24px_regular" : "confirm_24px_filled"
      }
      color="ghost"
      size="sm"
      loading={loading}
      onClick={onClick}
    />
  );
};
